export default __webpack_public_path__ + "static/media/pic_4.e4bd2016.png";